import { publicDocumentListLogout as publicDocumentListLogoutAPI } from '../api';
import { PUBLIC_DOCUMENT_LIST_PATH } from '../const';
import { useRouteMatch } from '@packages/router-dom';

export function usePublicDocumentListLogout() {
	const publicDocumentListPageMatch = useRouteMatch({ path: PUBLIC_DOCUMENT_LIST_PATH });
	const isPublicDocumentListPage = publicDocumentListPageMatch && publicDocumentListPageMatch.isExact;

	const handlePublicDocumentListLogout = () => {
		publicDocumentListLogoutAPI();
	};

	return {
		handlePublicDocumentListLogout,
		isPublicDocumentListPage,
	};
}
